// Indian rupee currency formatter — ₹1,23,456.78 (Indian numbering)
export const fmtINR = (n) => {
  if (n === null || n === undefined || n === '') return '—';
  const num = Number(n);
  if (Number.isNaN(num)) return '—';
  const fixed = num.toFixed(2);
  const [whole, dec] = fixed.split('.');
  const sign = whole.startsWith('-') ? '-' : '';
  const w = whole.replace(/^-/, '');
  const lastThree = w.slice(-3);
  const otherNumbers = w.slice(0, -3);
  const formatted = otherNumbers
    ? otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree
    : lastThree;
  return `${sign}₹${formatted}.${dec}`;
};

export const accentMap = {
  sky: 'from-sky-500 to-indigo-500',
  violet: 'from-violet-500 to-fuchsia-500',
  rose: 'from-rose-500 to-pink-500',
  amber: 'from-amber-500 to-orange-500',
  emerald: 'from-emerald-500 to-teal-500',
  slate: 'from-slate-500 to-slate-700',
};

export const inputCx = 'w-full px-3 py-2 rounded-xl bg-white border border-slate-200 text-[13px] focus:outline-none focus:border-sky-400 focus:ring-2 focus:ring-sky-100';
